import React from 'react';
import {Container, Row, Col, Image} from 'react-bootstrap';
import './Home.css';

const  About = () => {
    return ( 
        <Container>
  <Row>
    <Col xs={6} md={6} md={{ span: 6, offset: 3 }}>
        <Image src="https://res.cloudinary.com/dr0cgsqke/image/upload/v1611596770/nonedb/Benja_2_g6aj72.jpg" roundedCircle />
    </Col>
  </Row>
    <Row>
      <Col>
      <p><h2><span className="fontcolor">Benjamin C. Katubiya - CEO/Founder</span></h2></p>
            <p><bold>
            Thank you all for doing business with BUK Holdings Limited group of companies namely;
Æ BUK Truck Parts Limited
Æ BUK Commercials Services Limited
Æ Berea Automotive Limited

BUK Holdings Limited was born in 2014 out of the need to diversify business having started out with BUK Truck
Parts Limited, the flagship company of BUK Holdings limited. We celebrated 20 years anniversary of BUK Truck
Parts Limited and milestone thereof. The group is Zambian registered with all Zambian shareholders. Being a
local entity, we will strive to compete favourably, while offering our customers quality parts and services to
their satisfaction. One core mission of our business is to have a “sound business relationship" with all our
stakeholders bearing in mind the concept of “conscious capitalism”.
We want to engage you and co-operate with you for our mutual benefits and partnership.

Thank You
                </bold></p>  
       </Col>
    </Row>
  <Row>
    <Col xs={6} md={6}>
      <Image src="https://res.cloudinary.com/dr0cgsqke/image/upload/v1611596766/nonedb/Mrs_K_jqq6dy.jpg" roundedCircle />
      <p><h4><span className="fontcolor itemsimg">Upendo A. Katubiya</span></h4></p>
            <p><bold>
            <p><span className="fontcolor itemsimg">DIRECTOR OPERATIONS</span></p>
            </bold></p>
    </Col>
    <Col xs={6} md={6}>
      <Image src="https://res.cloudinary.com/dr0cgsqke/image/upload/v1611596766/nonedb/Mr_Simukwai_em70kt.jpg" roundedCircle />
      <p><h4><span className="fontcolor itemsimg">Benjamin V. Simukwai</span></h4></p>
            <p><bold>
            <p><span className="fontcolor itemsimg">REGIONAL DIRECTOR</span></p>
            </bold></p>
    </Col>
  </Row>
  <Row>
      <Col xs={6} md={6} md={{ span: 6, offset: 3 }}>
            <p><h4><span className="fontcolor">INDEPENDENT OF DIRECTORS</span></h4></p>
            <p><bold>
            <p>1. Mrs. Mirriam Chiyaba - CEO, Zambia Qualifications Authority</p>
            <p>2. Ms. Charlo􀆩e Mweemba - Legal Practitioner</p>
            <p>3. Mr. Robert Mtonga - Truckers Associaciation of Zambia</p>
            <p>4. Mr. Kayula Mulenga - Banker</p></bold></p>
       </Col>
    </Row>
</Container>)
}
 
export default About ;